import React, { useState, useEffect  } from 'react';
import axios from 'axios';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {formatDate, parseDate,} from 'react-day-picker/moment';
import Tools from './Tools';
import 'moment/locale/es';
import './css/Box.css';
import { ReactComponent as PlusIcon } from './icons/plus.svg';
import { ShowIcon, HideIcon } from '../components/icons/svgIcons';




const Box = (props) => {
    const [visibleMenu, setVisibleMenu] = useState(false);
    const [currentValue, setCurrentValue] = useState(null);
    const [currentOptions, setCurrentOptions] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    //const [childrenVisible, setChildrenVisible] = useState(false);
    const [calendarLimit, setCalendarLimit] = useState(null);
    
    useEffect(() => {

        if(!props.withoutLimits){
            if (props.limitDaysAfter){
                setCalendarLimit({ before: new Date(), after: Tools.addDays(new Date(), props.limitDaysAfter) });
            } else {
                setCalendarLimit({before: new Date()});
            }
        }


        if (props.genericListCode){
            axios.get(`${process.env.REACT_APP_URI_API_CRM}/generalLists`, {
                params: { companyId: props.companyId, code: props.genericListCode }
            })
            .then(function (response) {
                setCurrentOptions(response.data);
            })
            .catch(function (error) {
                console.log("Error:", error.message);
            });
        }
    }, [props.genericListCode])

    const indexesForSelect = props.colsSelect ? props.colsSelect:[0,1];

    const handleSelectChange = (event) => {
        setCurrentValue(event.target.value);
    }

    const toggleMenu = () => {
        setVisibleMenu(!visibleMenu);
    }

    let labelIfRequiredField = (props.required) ? 'required' : '';
    let labelClassName = (props.labelClassName) ? props.labelClassName : '';

    if (props.type === 'password') {
        return <div className={`inputWrapper ${(props.className) ? props.className : ''}`}>
            <label className={labelIfRequiredField}>{props.label}</label>
            <div className="passwordWrapper">
                <input type={showPassword ? 'text' : 'password'} name={props.name} defaultValue={props.value ? props.value : null} placeholder={props.placeholder} maxLength={props.maxlength} autoComplete="off" required={props.required} onChange={props.onChange} onKeyDown={props.onKeyDown}/>
                <button type="button" className="togglePassword" onClick={() => setShowPassword(!showPassword)} tabIndex={-1}>
                    {showPassword ? <HideIcon width="24" height="24" /> : <ShowIcon width="24" height="24"/>}
                </button>
            </div>
        </div>;
    }

    if (props.type === 'text' || props.type === 'number' ) {
        return <div className={`inputWrapper ${(props.className) ? props.className : ''}`}>
            <label className={labelIfRequiredField}>{props.label}</label>
            <input type={props.type} name={props.name} defaultValue={props.value ? props.value : null} placeholder={props.placeholder} maxLength={props.maxlength} autoComplete="off" autoCapitalize={props.autoCapitalize?props.autoCapitalize:undefined} required={props.required} onChange={props.onChange} onKeyDown={props.onKeyDown} max={props.max}/>
        </div>;
    }

    if (props.type === 'text+content') {
        return <div className={`inputWrapper ${(props.className) ? props.className : ''}`}>
            <label className={labelIfRequiredField}>{props.label}</label>
            <input type="text" autoFocus name={props.name} defaultValue={props.value ? props.value : null} placeholder={props.placeholder} maxLength={props.maxlength} autoComplete="off" required={props.required} onChange={props.onChange} onKeyDown={props.onKeyDown} onBlur={props.inputOnBlur}/>
            {(props.children) ? props.children : null}
        </div>;
    }

    if (props.type === 'content') {
        return (
        <div className={`inputWrapper ${(props.className) ? props.className : ''}`}>
            <label className={labelIfRequiredField}>{props.label}</label>
            {(props.children) ? props.children : null}
        </div>)
    }

    if (props.type === 'select') {
        return <div className={`inputWrapper select ${(props.className) ? props.className : ''}`}>
            <label className={labelIfRequiredField}>{props.label}</label>


            {/* PROPS/ACTIONS TO SHOW AN ADMIN WINDOW */}
            {props.adminMenuMethod ? (
                <a onClick={toggleMenu} className="moreButton"><PlusIcon/></a>
            ) : null}

            {(visibleMenu && props.adminMenuMethod) ? (
                <ul className="moreMenu">
                    <li><a onClick={() => { props.adminMenuMethod(props.entityToAdmin, 'NEW'); toggleMenu() }}>Nuevo</a></li>
                    <li><a onClick={() => { props.adminMenuMethod(props.entityToAdmin, 'EDIT'); toggleMenu() }}>Editar</a></li>
                    <li><a onClick={() => { props.adminMenuMethod(props.entityToAdmin, 'DELETE'); toggleMenu() }}>Eliminar</a></li>
                </ul>
            ) : null}

            <select name={props.name} defaultValue={props.defaultValue ? props.defaultValue : ""} value={props.value} onChange={props.onChange} required={props.required}>
                <option value="" disabled hidden>{props.placeholder}</option>
                {props.options ? 
                    props.options.map((option, index) =>
                        <option key={option[Object.keys(option)[indexesForSelect[0]]]} value={option[Object.keys(option)[indexesForSelect[0]]]}>{option[Object.keys(option)[indexesForSelect[1]]]}</option>
                    )
                    : (props.genericListCode && currentOptions && currentOptions.length>0) ?
                        currentOptions.map((option, index) =>
                            <option key={option[Object.keys(option)[indexesForSelect[0]]]} value={option[Object.keys(option)[indexesForSelect[0]]]}>{option[Object.keys(option)[indexesForSelect[1]]]}</option>
                        )
                    : null
                }
            </select>

        </div>
    }

    if (props.type === 'calendar') {
        return <div className={`inputWrapper ${(props.className) ? props.className : ''}`}>
            <label className={labelIfRequiredField}>{props.label}</label>

            <DayPickerInput
                value={props.selectedDate} 
                formatDate={formatDate}
                parseDate={parseDate} 
                format="DD/MM/YYYY"
                placeholder="Seleccione..."
                onDayChange={props.onChange}
                dayPickerProps={{
                    locale: 'es',
                    localeUtils: MomentLocaleUtils,
                    //disabledDays: {before: new Date()},
                    //disabledDays: { before: new Date(), after: Tools.addDays(new Date(), props.limitDaysAfter)},
                    disabledDays: calendarLimit
                }}
                inputProps={
                    { name: props.name, 
                      required: props.required,
                      autoComplete:'off',
                      readOnly:true
                    }
                } 
                
            />

        </div>;
    }

    if (props.type === 'readOnly') {
        let classNameForFieldType = props.fieldType ? props.fieldType.toLowerCase() : null;

        switch (props.fieldType) {
            case 'TXT':
                return (<div className={`fieldWrapper ${(props.className) ? props.className : ''}`}><label className={labelIfRequiredField}>{props.label}</label><div className={'value ' + classNameForFieldType}>{props.value}</div></div>);
                break;
            case 'TXTAREA':
                return (<div className={`fieldWrapper textArea ${(props.className) ? props.className : ''}`}><label className={labelIfRequiredField}>{props.label}</label><div className={'value ' + classNameForFieldType}>{props.value}</div></div>);
                break;
            case 'AMM':
                return (<div className={`fieldWrapper right ${(props.className) ? props.className : ''}`}><label className={'right ' + labelIfRequiredField}>{props.label}</label><div className={'value ' + classNameForFieldType}>{Tools.fmtClNumber(props.value)}</div></div>);
                break;
            case 'DATE':
                return (<div className={`fieldWrapper ${(props.className) ? props.className : ''}`}><label className={labelIfRequiredField}>{props.label}</label><div className={'value ' + classNameForFieldType}>{Tools.fdCL(props.value)}</div></div>);
                break;
            case 'LIST':
                return (<div className={`fieldWrapper ${(props.className) ? props.className : ''}`}><label className={labelIfRequiredField}>{props.label}</label><div className={'value ' + classNameForFieldType}>{props.value}</div></div>);
                break;
            case 'CONTENT':
                //return (<div className={`fieldWrapper ${(props.className) ? props.className : ''}`}><label className={labelIfRequiredField}>{props.label}</label><div className={'value ' + classNameForFieldType}>
                return (<div className={`fieldWrapper ${(props.className) ? props.className : ''}`}><label className={labelIfRequiredField}>{props.label}</label><div className={'value ' + classNameForFieldType} onDoubleClick={props.onDoubleClick}>
                    {/* {props.value} */}

                    {props.value.trim() !== '' ? (props.value) : <span className='placeholder'>{props.placeholder}</span>}


                    {(props.children) ? props.children : null}
                    </div></div>);
                break;
            default:
                return (
                <div className={`fieldWrapper ${(props.className) ? props.className : ''}`}>
                    <label className={labelIfRequiredField + ' ' + labelClassName} onClick={() => { if(props.toggleChildrensVisible){props.toggleChildrensVisible()} }} tooltip={props.tooltipLabel}>{props.label}</label>
                    <div className={'value ' + classNameForFieldType}>{props.value}</div>
                        {(props.children && props.showChildren && props.childrenVisible) ? props.children : null}
                </div>);
                break;    
        }  

    }
}

export default Box;